const styles = {
  labelIdent: {
    textAlign: "right",
    color:'gray',
    marginTop:'15px',
    fontWeight:'400',
    "@media (max-width: 600px)": {
      textAlign: "left",
      marginTop:'0px',
    },
    "@media only screen and (max-width: 750px) and (min-width: 601px)": {
      fontSize:'11px'
    },
  },
  containerin:{
    width:'100%'
  },
  boxTotalParcela:{
    background:'#f1f1f1'
  },
  boxValueParcela:{
    marginLeft:'10px',marginTop:'5px'
  },
  boxTotalPagamentoCt:{
    fontSize:'25px',fontWeight:'300',marginRight:'10px'
  }
};
export default styles;